import type {
  EntityAction,
} from '../types';

import * as actionTypes from './actionTypes';

export const requestFullWorkout = ({
  id,
  resourceType,
  addtionalType,
}: {
  id: number,
  resourceType: string,
  addtionalType: string,
}): EntityAction => ({
  type: actionTypes.REQUEST_FULL_WORKOUT,
  id,
  resourceType,
  addtionalType,
});
